
import { defineComponent, ref, computed, inject } from "vue";
import axios from "axios";
import { useField, useForm } from "vee-validate";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "Login",
  emits: ["selectSignup"],
  setup(_, { emit }) {
    const closeModal = inject("closeModal") as () => void;

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const loading = ref(false);

    const openForgotPass = () => {
      store.dispatch(ActionTypes.SET_MODAL, "forgotPassword");
    };

    const selectSignup = () => {
      emit("selectSignup");
    };

    const loginSchema = {
      email(value: string) {
        if (!value) {
          return "An email is required";
        }

        if (!value.match(emailRegex)) {
          return `${value} is not a valid email`;
        }

        return true;
      },
      password(value: string) {
        if (!value) {
          return "A password is required";
        }

        if (value.length < 3) {
          return "Password length must be at least three characters";
        }

        return true;
      }
    };

    useForm({
      validationSchema: loginSchema,
    });

    const {
      value: email,
      meta: emailMeta,
      errorMessage: emailError,
      handleChange: handleChangeEmail,
    } = useField("email");

    const {
      value: password,
      meta: passwordMeta,
      errorMessage: passwordError,
      handleChange: handleChangePassword,
    } = useField("password");

    const generalError = ref("");
    const unregisteredError = ref(false);
    const canLogin = computed<boolean>(() => emailMeta.valid && passwordMeta.valid);

    const handleSubmit = async () => {
      loading.value = true;

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/editor/customers/ajax.php?mode=login`,
          {
            email: email.value,
            password: password.value,
          }
        );

        if (typeof res.data.error !== "undefined") {
          if (res.data.message.includes("email is not registered")) {
            unregisteredError.value = true;
          } else {
            generalError.value = res.data.message;
          }
        } else {
          generalError.value = "";
          unregisteredError.value = false;

          closeModal();
        }

        loading.value = false;
      } catch (e) {
        console.log(e);
        loading.value = false;
      }
    };

    return {
      loading,
      email,
      emailError,
      handleChangeEmail,
      password,
      passwordError,
      handleChangePassword,
      openForgotPass,
      selectSignup,
      generalError,
      unregisteredError,
      canLogin,
      handleSubmit,
    };
  },
});
